import { Transition } from "../../../../core/flows/Transition";
import { SelectOfferContext } from "../Context/SelectOfferContext";


export class SelectOfferTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {        
        const context = this.getCtx<SelectOfferContext>("SelectOfferContext", this.entryStep);        
        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}